var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.5 -8.825)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#26B963",
    strokeWidth: "0.75px",
    transform: "translate(8.5 8.825)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    stroke: "none",
    width: 14,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.375,
    y: 0.375,
    width: 13.25,
    height: 13.25,
    rx: 1.625
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#26B963",
    d: "M206.647,170.191a.366.366,0,0,0-.6,0l-2.409,3.072a.553.553,0,0,0,.021.689.362.362,0,0,0,.576-.024l1.69-2.164V177.1a.417.417,0,1,0,.822,0v-5.334l1.7,2.164a.392.392,0,0,0,.3.156.376.376,0,0,0,.279-.132.553.553,0,0,0,.021-.689Zm0,0",
    transform: "translate(-190.528 -158.233)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.8b6fe9d8efc80ae5afb6b7af20ece037.svg";
export { ForwardRef as ReactComponent };